import Vue from 'vue';
export default Vue.extend({
  name: 'transitionable',
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/vuetify/lib/mixins/transitionable/index.js